(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["he-product-qa"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('[data-he-variant-select]').forEach(function(select){select.addEventListener('change',function(){var url=new URL(window.location.href);url.searchParams.set('variant',select.value);window.location.assign(url.toString());});});
  } catch(e) { console.error(e); }
})();

})();
